import React from "react";
import { Facebook, Instagram, Search, Store, MessageCircle } from "lucide-react";
import { SOURCE_LABEL } from "../lib/api";

const ICONS = {
  "meta-fb": Facebook,
  "meta-ig": Instagram,
  google: Search,
  offline: Store,
  whatsapp: MessageCircle,
};

const ICON_COLORS = {
  whatsapp: "#25D366",
};

export function SourceBadge({ source }) {
  const Icon = ICONS[source] || Store;
  const iconColor = ICON_COLORS[source];
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border border-[#E8EAEF] bg-[#F0F1F7] px-2.5 py-1 text-xs text-[#1A1A2E] font-[600]"
      data-testid={`source-badge-${source}`}
    >
      <Icon className="h-3.5 w-3.5" style={iconColor ? { color: iconColor } : undefined} />
      {SOURCE_LABEL[source] || source}
    </span>
  );
}
